import Select from "react-select";
import { reactSelectSMStyle, styles } from "Utils/Common";
import useLang from "Shared/hooks/useLanguage";
import { SelectOption } from "../types";

interface StepReagentSelectProps {
  reagentOptions: SelectOption[];
  selectedReagent: string;
  onReagentChange: (value: string) => void;
}

export function StepReagentSelect({
  reagentOptions,
  selectedReagent,
  onReagentChange,
}: StepReagentSelectProps) {
  const { t } = useLang();

  return (
    <div className="mt-3">
      <label
        className="form-label mb-1 fw-500"
        style={{ fontSize: "13px", color: "#333" }}
      >
        {t("Please select a reagents")}
      </label>
      <Select
        theme={(theme) => styles(theme)}
        options={reagentOptions}
        value={reagentOptions.find((r) => String(r.value) === selectedReagent) || null}
        styles={{
          ...reactSelectSMStyle,
          control: (provided) => ({
            ...provided,
            minWidth: "100%",
            border: "1px solid #e5e5e5",
            borderRadius: "6px",
            "&:hover": {
              border: "1px solid #e5e5e5",
            },
          }),
        }}
        menuPortalTarget={document.body}
        placeholder={`--- ${t("Select")} ---`}
        isSearchable={true}
        onChange={(opt) => {
          const selected = opt as SelectOption | null;
          onReagentChange(selected ? String(selected.value) : "");
        }}
      />
    </div>
  );
}
